import CircularProgress from "components/CircularProgress";
import Nprogress from "nprogress";
import "nprogress/nprogress.css";
import { Component, Suspense } from "react";
import ReactPlaceholder from "react-placeholder";
import { RectShape, TextBlock } from "react-placeholder/lib/placeholders";
import "react-placeholder/lib/reactPlaceholder.css";

export default function asyncComponent(importComponent, options = {}) {
  const { skipPlaceholder = false } = options;

  class AsyncFunc extends Component {
    constructor(props) {
      super(props);
      this.state = {
        component: null,
        error: null,
      };
    }

    async componentDidMount() {
      Nprogress.start();
      this.mounted = true;
      try {
        const { default: Component } = await importComponent();
        if (this.mounted) {
          this.setState({ component: <Component {...this.props} /> });
        }
      } catch (error) {
        if (this.mounted) {
          this.setState({ error });
        }
      } finally {
        Nprogress.done();
      }
    }

    componentWillUnmount() {
      this.mounted = false;
    }

    render() {
      const { component: Component, error } = this.state;

      if (error) {
        return <div>Error: {error.message}</div>;
      }

      // For skipPlaceholder, render component directly without any loading UI
      if (skipPlaceholder && Component) {
        return Component;
      }

      // For skipPlaceholder but component not loaded yet, render nothing
      if (skipPlaceholder && !Component) {
        return null;
      }

      return (
        <Suspense
          fallback={
            <div
              style={{
                height: "100dvh",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <CircularProgress />
              <p>Loading...</p>
            </div>
          }
        >
          <ReactPlaceholder
            className="gx-mt-3"
            showLoadingAnimation
            customPlaceholder={
              <div className="flex gx-flex-column">
                <TextBlock rows={1} color="#ccc" className="gx-mb-3" />
                <TextBlock rows={1} color="#ccc" className="gx-mb-4" />
                <TextBlock rows={2} color="#ccc" className="gx-mb-3" />
                <RectShape
                  color="#ccc"
                  style={{ width: "100%", height: "7dvh" }}
                />

                <TextBlock rows={3} color="#ccc" className="gx-my-5" />
                <RectShape
                  color="#ccc"
                  className="gx-mb-2"
                  style={{ width: "100%", height: "15dvh" }}
                />
                <RectShape
                  color="#ccc"
                  className="gx-mb-2"
                  style={{ width: "100%", height: "15dvh" }}
                />
                <RectShape
                  color="#ccc"
                  className="gx-mb-2"
                  style={{ width: "100%", height: "15dvh" }}
                />
              </div>
            }
            ready={Component !== null}
          >
            {Component}
          </ReactPlaceholder>
        </Suspense>
      );
    }
  }

  return AsyncFunc;
}
